import { getSnowplowEventPayload, logAnalyticsEvent } from '../../analytics';
import { SNOWPLOW_EVENTS } from '../../analytics.const';

import { VEHICLE_DETAILS_IMAGE_EVENTS, VEHICLE_DETAILS_IMAGE_SECTIONS } from './galleryEvents.consts';
import type { VehicleDetailsImageSectionsKeys } from './galleryEvents.types';

export const triggerImageZoomExitEvent = (section: VehicleDetailsImageSectionsKeys): void => {
	const snowplowEventPayload = getSnowplowEventPayload({
		category: VEHICLE_DETAILS_IMAGE_SECTIONS[section],
		name: VEHICLE_DETAILS_IMAGE_EVENTS.ZOOM_EXIT.snowplow,
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload: snowplowEventPayload });
};
